export const BOUNDS_PADDING = 0.1;
export const FOCUS_ZOOM = 17;
export const ROUTE_COLOR = '#006eff';
export const HIGHLIGHTED_ROUTE_COLOR = '#152239';
export const SIDE_PANEL_WIDTH_PX = 440;
